export default __webpack_public_path__ + "static/media/AtomsAndCompounds _08.770de8ac.png";